export const PopupClose = ({ className = '' }) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M14.7 1.8C14.3 1.4 13.7 1.4 13.3 1.8L8 7.1L2.7 1.8C2.3 1.4 1.7 1.4 1.3 1.8C0.9 2.2 0.9 2.8 1.3 3.2L6.6 8.5L1.3 13.8C0.9 14.2 0.9 14.8 1.3 15.2C1.5 15.4 1.7 15.5 2 15.5C2.3 15.5 2.5 15.4 2.7 15.2L8 9.9L13.3 15.2C13.5 15.4 13.8 15.5 14 15.5C14.2 15.5 14.5 15.4 14.7 15.2C15.1 14.8 15.1 14.2 14.7 13.8L9.4 8.5L14.7 3.2C15.1 2.8 15.1 2.2 14.7 1.8Z'
        fill='#303538'
      />
    </svg>
  )
}
